<template>
    <div>
        <div class="p-t-16 input-wysiwyg">
            <div class="d-flex-between-center tool-bar m-d-16">
                <div class="operation">
                    <label @click="setBold" class="f-bold f-16 f-c-black m-r-16 m-d-0">B</label>
                    <label @click="setItalic" class="f-bold f-16 f-c-black m-r-16 m-d-0">I</label>
                    <label class="m-d-0" @click="showModal('modal-src')"
                        ><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M11 1.99976C6.02944 1.99976 2 6.02919 2 10.9998C2 15.9703 6.02944 19.9998 11 19.9998C15.9706 19.9998 20 15.9703 20 10.9998C20 6.02919 15.9706 1.99976 11 1.99976ZM0 10.9998C0 4.92462 4.92487 -0.000244141 11 -0.000244141C17.0751 -0.000244141 22 4.92462 22 10.9998C22 17.0749 17.0751 21.9998 11 21.9998C4.92487 21.9998 0 17.0749 0 10.9998ZM11 5.99998C11.5523 5.99998 12 6.4477 12 6.99998V9.99998H15C15.5523 9.99998 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H12V15C12 15.5523 11.5523 16 11 16C10.4477 16 9.99999 15.5523 9.99999 15V12H7.00001C6.44773 12 6.00001 11.5523 6.00001 11C6.00001 10.4477 6.44773 9.99998 7.00001 9.99998H9.99999V6.99998C9.99999 6.4477 10.4477 5.99998 11 5.99998Z"
                                fill="#964040"
                            />
                        </svg>
                    </label>
                </div>
                <div class="actions d-flex-between-center">
                    <div class="m-r-8" @click="showModal('modal-preview')">
                        <label class="m-d-0 f-c-blue f-14 f-semi">Preview</label>
                    </div>
                    <div>
                        <SOButton
                            :primary="true"
                            :text="'Simpan'"
                            :id="'save-template'"
                            :disable="!allowSave"
                            :loading="isFetching"
                            @action="saving"
                            @hook:mounted="onMounted"
                        />
                    </div>
                </div>
            </div>
            <textarea class="editable" id="editable" v-model="newContent"></textarea>
        </div>
        <div class="modal-src">
            <SOSlotModal :modal-title="`Tambahkan Shortcode`" :modal-id="`modal-src`" @close="hideModal('modal-src')">
                <template v-slot:modal-body>
                    <div>
                        <div class="m-d-16">
                            <SOInputSearch id="cari-shortcode" value="" :doSearching="doSearch" :delay-time="2000" />
                        </div>
                        <div class="data-list">
                            <div v-if="isLoadShortcode" style="min-height: 100px">
                                <SOLoadMoreLoading :id="'search-short-code'" :loading="isLoadShortcode" />
                            </div>
                            <div v-else>
                                <div
                                    v-for="(data, key) in listShortcode"
                                    :key="`${data.code}-${key}`"
                                    class="d-flex-between-center p-x-4 p-y-8 border-bottom-EDED"
                                    @click="insertShortcode(data)"
                                >
                                    <div style="max-width: 80vw;">
                                        <p class="m-d-0" v-html="spanShortcode(data.code)"></p>
                                        <p class="m-d-0">{{ data.keterangan }}</p>
                                    </div>
                                    <div>
                                        <svg
                                            width="8"
                                            height="13"
                                            viewBox="0 0 8 13"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M0.91107 12.0894C0.585633 11.764 0.585633 11.2363 0.91107 10.9109L5.32181 6.50016L0.911069 2.08942C0.585632 1.76398 0.585632 1.23634 0.911069 0.910906C1.23651 0.585468 1.76414 0.585468 2.08958 0.910906L7.08958 5.91091C7.41502 6.23634 7.41502 6.76398 7.08958 7.08942L2.08958 12.0894C1.76414 12.4149 1.23651 12.4149 0.91107 12.0894Z"
                                                fill="#C8D0DD"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </SOSlotModal>
            <SOSlotModal :modal-title="`Preview`" :modal-id="`modal-preview`" @close="hideModal('modal-preview')">
                <template v-slot:modal-body>
                    <div class="message-wrapper">
                        <div class="msg-head">
                            <div class="d-flex-between-center" style="align-items: unset;">
                                <SOInputOnOff :checkboxes="getCheckbox" @selected="toogleOnOff" :checked="isDrafted" />
                            </div>
                        </div>
                        <div class="msg msg-body f-14" v-html="getTextMsgPreview" v-if="isDrafted"></div>
                        <div class="msg msg-body f-14" v-html="getTextMsg" v-else></div>
                    </div>
                </template>
            </SOSlotModal>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOButton from "@/so-components/global/ui/SOButton";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff.vue";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputSearch from "@/so-components/global/input/SOInputSearch";

const previewMode = {
    id: "preview-mode",
    data: {
        name: "preview-mode",
        data: [
            {
                id: "preview-mode",
                value: "1",
                title: `<label class='f-regular f-14 f-c-black m-0' for='preview-mode'>Preview data</label>`,
                checked: false,
                titleBold: false,
            },
        ],
    },
};

export default {
    name: "SOInputWysiwyg",
    props: {
        defaultContent: {
            type: String,
            default: "",
        },
        category: {
            type: String,
            default: "transaksi", //ambil | beli_deposit | beli_emoney | selesai | transaksi | ultah | blast
        },
        savingUpdate: {
            type: Function,
            required: true,
        },
        isFetching: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        SOButton,
        SOInputOnOff,
        SOLoadMoreLoading,
        SOSlotModal,
        SOInputSearch,
    },
    data() {
        return {
            newContent: "",
            isLoadShortcode: false,
            isDrafted: false,
            listShortcode: [],
            draftShortcode: [],
        };
    },
    mounted() {
        setTimeout(() => {
            this.init();
        }, 100);
    },
    computed: {
        ...mapGetters("metaModule", {
            shortcode: "shortcode",
        }),
        allowSave() {
            return this.newContent !== this.defaultContent;
        },
        getTextMsg() {
            let textMsg = this.newContent
                .replace(/\n/g, "<br />")
                .replace(/\*([\w \@\#\%\&\*\(\)\"\'\:\[\]\-]*)\*/g, "<b>$1</b>")
                .replace(/\_([\w \@\#\%\&\*\(\)\"\'\:\[\]\-]*)\_/g, "<i>$1</i>")
                .replace(/\[([^\[\]\~]+)\]/g, "<span class='key-src'>$1</span>");

            return textMsg;
        },
        getTextMsgPreview() {
            if (this.isDrafted) {
                let textmsg = this.newContent;

                this.getShortkey.forEach((sk) => {
                    let sc = this.listShortcode.find((ls) => ls.code === `${sk}]`);
                    if (sc !== undefined) {
                        textmsg = textmsg.replace(`${sk}]`, sc.sample);
                    }
                });

                return textmsg
                    .replace(/\n/g, "<br />")
                    .replace(/\*([^\*\~]+)\*/g, "<b>$1</b>")
                    .replace(/\_([^\_\~]+)\_/g, "<i>$1</i>");
            } else {
                return this.getTextMsg;
            }
        },
        spanShortcode() {
            return (text) => {
                return text.replace(/\[([^\[\]\~]+)\]/g, "<span class='key-src'>$1</span>");
            };
        },
        getShortkey() {
            return this.newContent.match(/(?=\[)(.*?)(?=\])/g);
        },
        getCheckbox() {
            return previewMode.data;
        },
    },
    methods: {
        ...mapActions({
            getShortcode: `metaModule/getShortcode`,
        }),
        async init() {
            await this.setDefaultContent();
        },
        onMounted() {
            let btn = document.getElementById("save-template");
            btn.style.margin = "0px";
            btn.style.minWidth = "78px";
        },
        toogleOnOff(val) {
            this.isDrafted = val;
        },
        setDefaultContent() {
            this.newContent = this.defaultContent;
        },
        setBold() {
            let textarea = document.getElementById("editable");
            let start = textarea.selectionStart;
            let end = textarea.selectionEnd;

            let sel = textarea.value.substring(start, end);

            if (sel.length > 0) {
                let boldText = `*${sel}*`;
                this.newContent = textarea.value.substring(0, start) + boldText + textarea.value.substring(end);

                textarea.value = this.newContent;
                textarea.focus();
                textarea.selectionEnd = end + 2;
            }
        },
        setItalic() {
            let textarea = document.getElementById("editable");
            let start = textarea.selectionStart;
            let end = textarea.selectionEnd;

            let sel = textarea.value.substring(start, end);

            if (sel.length > 0) {
                let boldText = `_${sel}_`;
                this.newContent = textarea.value.substring(0, start) + boldText + textarea.value.substring(end);

                textarea.value = this.newContent;
                textarea.focus();
                textarea.selectionEnd = end + 2;
            }
        },
        insertShortcode(data) {
            let textarea = document.getElementById("editable");
            let start = textarea.selectionStart;
            let end = textarea.selectionEnd;

            this.newContent = textarea.value.substring(0, start) + data.code + textarea.value.substring(end);

            this.hideModal("modal-src");
            setTimeout(() => {
                textarea.value = this.newContent;
                textarea.focus();
                textarea.selectionStart = end + data.code.length;
                textarea.selectionEnd = end + data.code.length;
            }, 100);
        },
        doSearch(searchKey, modalId) {
            this.isLoadShortcode = true;

            this.getShortcode({ searchKey, category: this.category })
                .then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200 && status) {
                        this.listShortcode = data;
                        if (!searchKey && modalId === "modal-src") {
                            this.draftShortcode = data;
                        }
                    }
                    this.isLoadShortcode = false;
                })
                .catch((e) => {
                    this.isLoadShortcode = false;
                    this.$toast.error(e);
                });
        },
        hideModal(modalId) {
            $(`#${modalId}`).modal("hide");
        },
        showModal(modalId) {
            $(`#${modalId}`).modal("show");
            this.doSearch("", modalId);
            if (modalId === "modal-preview") {
                this.isDrafted = false;
            }
        },
        saving() {
            if (!this.isFetching) {
                this.savingUpdate(this.removeSpecialChar(this.newContent));
            }
        },
    },
};
</script>
<style scoped>
.p-x-4 {
    padding-left: 4px;
    padding-right: 4px;
}
.data-list {
    max-height: 50vh;
    overflow: hidden;
    overflow-y: scroll;
}
.editable {
    background-color: #ffffff;
    width: 100%;
    height: 60vh;
    border: unset;
}
.input-wysiwyg {
    background-color: #ffffff;
    padding: 13px;
    border-radius: 8px;
}
.input-wysiwyg .tool-bar {
    box-shadow: 0px 4px 12px rgba(0, 34, 119, 0.06);
    border-bottom: 8px solid #ededed;
    margin-left: -13px;
    margin-right: -13px;
    padding: 8px 13px;
}
.message-wrapper {
    background: #ede7de;
    margin: 0px -20px;
    margin-top: -4px;
    padding: 20px;
    max-height: 70vh;
    overflow-y: scroll;
    overflow-x: hidden;
}
.msg {
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 8px 12px;
}
.msg-head {
    background: inherit;
    margin-bottom: 20px;
}
.msg-body {
    background: #e0ffc6;
}
</style>
